// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const terrakion: PokeData = {
  "id": 639,
  "name": "terrakion",
  "height": 19,
  "weight": 2600,
  "base_experience": 261,
  "types": [
    PokeType.ROCK,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "swords-dance",
    "double-kick",
    "take-down",
    "leer",
    "quick-attack",
    "rock-slide",
    "helping-hand",
    "close-combat",
    "stone-edge",
    "smack-down",
    "quick-guard",
    "retaliate",
    "work-up",
    "sacred-sword"
  ],
  "moves": [
    "double-kick",
    "leer",
    "quick-attack",
    "rock-slide",
    "close-combat",
    "drain-punch",
    "coaching",
    "stone-crush",
    "rock-blast",
    "rock-smash",
    "rock-tomb",
    "meteor-assault",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 326,
    "item": null,
    "species": [
      {
        "name": "terrakion",
        "order": 640,
        "types": [
          PokeType.ROCK,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 132,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
